import { useTranslation } from "react-i18next";
import { Badge } from "../../../shared-ui/primitives";

export function DraftStatusBadge({ status }: { status: "draft" | "confirmed" | "locked" }) {
  const { t } = useTranslation("dailyEntry");
  if (status === "confirmed") return <Badge tone="success">✓ {t("status.confirmed")}</Badge>;
  if (status === "locked") return <Badge tone="neutral">🔒 {t("status.locked")}</Badge>;
  return <Badge tone="neutral">● {t("status.draft")}</Badge>;
}
